var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe1178(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1532 23.6328V38.3289C46.1532 38.7345 46.0723 39.1362 45.9151 39.5109C45.7579 39.8857 45.5275 40.2262 45.237 40.513C44.9465 40.7998 44.6017 41.0273 44.2222 41.1825C43.8427 41.3378 43.4359 41.4176 43.0251 41.4176H3.71792C2.8883 41.4176 2.09268 41.0922 1.50605 40.513C0.919427 39.9337 0.589844 39.1481 0.589844 38.3289V13.6588C0.589844 12.8396 0.919427 12.0539 1.50605 11.4747C2.09268 10.8954 2.8883 10.57 3.71792 10.57H28.1518",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7561 30.6065H8.41128C7.58166 30.6065 6.78603 30.2811 6.1994 29.7018C5.61277 29.1226 5.2832 28.337 5.2832 27.5178V18.2904C5.2832 17.4712 5.61277 16.6856 6.1994 16.1063C6.78603 15.5271 7.58166 15.2017 8.41128 15.2017H17.7561C18.5857 15.2017 19.3814 15.5271 19.968 16.1063C20.5546 16.6856 20.8842 17.4712 20.8842 18.2904V27.5178C20.8842 28.337 20.5546 29.1226 19.968 29.7018C19.3814 30.2811 18.5857 30.6065 17.7561 30.6065Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6133 15.2026H32.1648",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6133 30.6065H41.4653",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2832 33.6953H41.4623",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2832 36.784H41.4623",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6133 27.5178H41.4653",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6133 18.2914H34.2728",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8585 22.0218C16.8585 23.0109 16.4606 23.9595 15.7523 24.6589C15.044 25.3583 14.0833 25.7512 13.0816 25.7512C12.0806 25.7502 11.1209 25.3568 10.4134 24.6575C9.70598 23.9582 9.30859 23.0102 9.30859 22.0218C9.30911 21.0337 9.70672 20.0861 10.4141 19.3873C11.1215 18.6884 12.0809 18.2953 13.0816 18.2943C14.0829 18.2943 15.0433 18.6869 15.7516 19.3859C16.4598 20.0849 16.858 21.033 16.8585 22.0218Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6137 30.4879C18.4239 29.1733 17.7601 27.9704 16.7444 27.1001C15.7286 26.2298 14.429 25.7505 13.0842 25.7502C11.7394 25.7505 10.4398 26.2298 9.42402 27.1001C8.40827 27.9704 7.74454 29.1733 7.55469 30.4879",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4088 11.0153C52.4092 12.3853 52.1362 13.742 51.6054 15.0078C51.0746 16.2737 50.2964 17.4238 49.3153 18.3926C48.3342 19.3614 47.1694 20.1298 45.8875 20.6539C44.6055 21.178 43.2315 21.4476 41.844 21.4472C40.4566 21.4475 39.0827 21.1778 37.8008 20.6536C36.5189 20.1295 35.3541 19.3611 34.3731 18.3923C33.392 17.4236 32.6138 16.2735 32.0829 15.0077C31.5521 13.7419 31.279 12.3853 31.2793 11.0153C31.2792 9.64528 31.5523 8.2887 32.0832 7.02298C32.6141 5.75726 33.3923 4.6072 34.3734 3.63848C35.3544 2.66976 36.5191 1.90135 37.8009 1.37715C39.0828 0.852936 40.4566 0.583185 41.844 0.583313C43.2314 0.583185 44.6053 0.852936 45.8872 1.37715C47.169 1.90135 48.3337 2.66976 49.3147 3.63848C50.2958 4.6072 51.074 5.75726 51.6049 7.02298C52.1358 8.2887 52.4089 9.64528 52.4088 11.0153Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3887 12.1295L39.4937 14.2081C39.6768 14.3881 39.9246 14.4892 40.183 14.4892C40.4413 14.4892 40.6891 14.3881 40.8722 14.2081L46.2973 8.85114",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1178);
export default __webpack_public_path__ + "static/media/Groupe 1178.088a67fc18dd56c53d0e5294d93db7e6.svg";
export { ForwardRef as ReactComponent };